import { render, staticRenderFns } from "./CompanyDashboard.vue?vue&type=template&id=0e77bf4a&scoped=true&"
import script from "./CompanyDashboard.vue?vue&type=script&lang=ts&"
export * from "./CompanyDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDashboard.vue?vue&type=style&index=0&id=0e77bf4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e77bf4a",
  null
  
)

export default component.exports